import { Modal, Button, Footer, Header } from '@legalzoom/ui/negroni';

type ConsultConfirmationModalProps = {
  isOpen: boolean;
  modalHeading: string;
  modalSubheading: string;
  onClose: () => void;
  onPrimaryCtaClick: () => void;
  onSecondaryCtaClick: () => void;
};

export default function ConsultConfirmationModal({
  isOpen,
  modalHeading,
  modalSubheading,
  onClose,
  onPrimaryCtaClick,
  onSecondaryCtaClick,
}: ConsultConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(val) => {
        if (!val) {
          onClose();
        }
      }}
    >
      <Header title={modalHeading} subtitle={modalSubheading} />
      <Footer>
        <Button slot="close" onPress={onSecondaryCtaClick}>
          Back
        </Button>
        <Button slot="cta" onPress={onPrimaryCtaClick}>
          Schedule anyway
        </Button>
      </Footer>
    </Modal>
  );
}
